import React from "react";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import { Dialog } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { Container } from "@mui/material";
import { useViewport } from "../../helpers";

const PREFIX = "ResponsiveDialogManager";

const classes = {
  appBar: `${PREFIX}-appBar`,
  appBarMobile: `${PREFIX}-appBarMobile`,
  title: `${PREFIX}-title`,
  overflowMod: `${PREFIX}-overflowMod`,
};

const StyledDialog = styled(Dialog)(({ theme }) => ({
  [`& .${classes.appBar}`]: {
    position: "relative",
    backgroundColor: "#D3AF5F",
  },

  [`& .${classes.appBarMobile}`]: {
    position: "relative",
    paddingTop: "40px",
  },

  [`& .${classes.title}`]: {
    marginLeft: theme.spacing(2),
    flex: 1,
    color: "white",
  },

  [`& .${classes.overflowMod}`]: {
    overflow: "auto",
    height: "100%",
    backgroundColor: "#424242",
    "&::-webkit-scrollbar": {
      width: "5px",
      height: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#D3AF5F",
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "rgb(181 154 79 / 58%)",
      borderRadius: "10px",
    },
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" in={true} ref={ref} {...props} />;
});

export default function ResponsiveDialogManager(props) {
  const { onClose, selectedValue, open } = props;
  const { width } = useViewport();

  const handleClose = () => {
    onClose(selectedValue);
  };

  return (
    <StyledDialog
      fullScreen={width <= 1024 || props.fullScreen}
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      disableEscapeKeyDown={props.noClose}
    >
      <AppBar className={classes.appBar}>
        <Toolbar className={props.mobile ? classes.appBarMobile : null}>
          {!props.noClose && (
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
              size="large"
            >
              <CloseIcon sx={{ color: "black" }} />
            </IconButton>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: props.isUnder ? "column" : "row",
              margin: props.isUnder ? "0 auto" : "inherit",
              width: "100%",
              justifyContent: !props.isUnder && "space-between",
            }}
          >
            <div style={{ alignSelf: props.isUnder && "center" }}>
              <Typography
                variant="h6"
                className={classes.title}
                style={{
                  marginLeft: props.isUnder && "0",
                  position: !props.isUnder && "relative",
                  top: !props.isUnder && "50%",
                  transform: !props.isUnder && "translateY(-50%)",
                }}
              >
                {props.title}
              </Typography>
            </div>
            {props.toolbarActions && (
              <div
                style={{
                  width: props.isUnder && "100%",
                }}
              >
                {props.toolbarActions}
              </div>
            )}
          </div>
        </Toolbar>
      </AppBar>
      <Container
        className={classes.overflowMod}
        disableGutters={props.disableGutters}
        style={{ maxWidth: width > 1024 && props.fullScreen && "none" }}
      >
        {props.renderer}
      </Container>
    </StyledDialog>
  );
}

ResponsiveDialogManager.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};
